import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { useState, useEffect } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useAuth } from "../../context/auth-context";
import "./style.css";

const LoginDetails = () => {
  const { user } = useAuth();
  const [id, setId] = useState("");
  const [username, setUsername] = useState("");
  const [mail, setMail] = useState("");
  const [tcNo, setTcNo] = useState("");
  const [birthday, setBirthday] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(true);
  const [updating, setUpdating] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const togglePasswordVisibility = () => setShowPassword(!showPassword);
  const toggleConfirmPasswordVisibility = () =>
    setShowConfirmPassword(!showConfirmPassword);

  // Profil bilgilerini yükle
  useEffect(() => {
    const fetchProfile = async () => {
    try {
        setLoading(true);
        const response = await fetch("https://app.vivasmartcare.com/api/profile", {
          method: "GET",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
        });

      if (response.ok) {
          const userInfo = await response.json();
          setId(userInfo.id || "");
          setUsername(userInfo.username || "");
          setMail(userInfo.mail || "");
          setTcNo(userInfo.tcNo || "");
          setBirthday(userInfo.birthday || "");
          setPhoneNumber(userInfo.phoneNumber || "");
      } else {
          setError("Profil bilgileri yüklenirken bir hata oluştu.");
      }
    } catch (error) {
        console.error("Profil yükleme hatası:", error);
        setError("Bağlantı hatası. Lütfen tekrar deneyin.");
      } finally {
        setLoading(false);
      }
    };

    if (user) {
      fetchProfile();
    }
  }, [user]);

  async function updateLoginDetail() {
    // Hata ve başarı mesajlarını temizle
    setError("");
    setSuccess("");

    // Validasyonlar
    if (!username.trim()) {
      setError("Kullanıcı adı boş bırakılamaz.");
      return;
    }

    if (!mail.trim()) {
      setError("E-posta adresi boş bırakılamaz.");
      return;
    }

    if (!tcNo.trim()) {
      setError("TC No boş bırakılamaz.");
      return;
    }

    if (!birthday.trim()) {
      setError("Doğum tarihi boş bırakılamaz.");
      return;
    }

    if (!phoneNumber.trim()) {
      setError("Telefon numarası boş bırakılamaz.");
      return;
    }

    // E-posta format kontrolü
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(mail)) {
      setError("Geçerli bir e-posta adresi giriniz.");
      return;
    }

    // Şifre kontrolü - şifre girilmişse kontrol et
    if (password || confirmPassword) {
      if (password !== confirmPassword) {
        setError("Yeni şifreler eşleşmiyor!");
        return;
      }

      if (password.length < 6) {
        setError("Şifre en az 6 karakter olmalıdır.");
        return;
      }
    }

    try {
      setUpdating(true);
      const response = await fetch("https://app.vivasmartcare.com/api/login-update", {
        method: "PUT",
        body: JSON.stringify({
          username,
          mail,
          tcNo,
          birthday,
          phoneNumber,
          password: password || undefined, // Şifre boşsa gönderme
        }),
        headers: { "Content-Type": "application/json" },
        credentials: "include",
      });

      const data = await response.json();

      if (response.ok) {
        setSuccess("Kullanıcı bilgileri başarıyla güncellendi.");
        // Şifre alanlarını temizle
        setPassword("");
        setConfirmPassword("");
        // 2 saniye sonra sayfayı yenile
        setTimeout(() => {
        window.location.reload();
        }, 2000);
      } else {
        setError(data.message || "Kullanıcı güncellenirken bir hata oluştu.");
      }
    } catch (error) {
      console.error("Güncelleme işlemi sırasında bir hata oluştu:", error);
      setError("Bağlantı hatası. Lütfen tekrar deneyin.");
    } finally {
      setUpdating(false);
    }
  }

  if (loading) {
    return (
      <div className="login-details-loading">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Yükleniyor...</span>
        </div>
        <p>Profil bilgileri yükleniyor...</p>
      </div>
    );
  }

  return (
    <>
      <div className="login-details-wrapper">
        <div className="login-details-header">
          <h2>Kullanıcı Giriş Bilgileri</h2>
          <p className="login-details-subtitle">
            Profil bilgilerinizi buradan görüntüleyebilir ve güncelleyebilirsiniz.
          </p>
        </div>

        {/* Hata ve Başarı Mesajları */}
        {error && (
          <div className="alert alert-danger" role="alert">
            {error}
          </div>
        )}
        {success && (
          <div className="alert alert-success" role="alert">
            {success}
          </div>
        )}

        <div className="login-details-card">
          <div className="login-details-form">
            <div className="form-group">
              <label htmlFor="username">Kullanıcı Adı</label>
              <Form.Control
                id="username"
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="Kullanıcı adınızı giriniz"
              />
            </div>

            <div className="form-group">
              <label htmlFor="mail">E-posta Adresi</label>
              <Form.Control
                id="mail"
                type="email"
                value={mail}
                onChange={(e) => setMail(e.target.value)}
                placeholder="E-posta adresinizi giriniz"
              />
            </div>

            <div className="form-group">
              <label htmlFor="tcNo">TC Kimlik No</label>
              <Form.Control
                id="tcNo"
                type="text"
                value={tcNo}
                onChange={(e) => setTcNo(e.target.value)}
                placeholder="TC Kimlik numaranızı giriniz"
                maxLength={11}
              />
            </div>

            <div className="form-group">
              <label htmlFor="birthday">Doğum Tarihi</label>
              <Form.Control
                id="birthday"
                type="date"
                value={birthday}
                onChange={(e) => setBirthday(e.target.value)}
              />
            </div>

            <div className="form-group">
              <label htmlFor="phoneNumber">Telefon Numarası</label>
              <Form.Control
                id="phoneNumber"
                type="tel"
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value)}
                placeholder="Telefon numaranızı giriniz"
              />
            </div>

            <div className="form-group password-field">
              <label htmlFor="password">Yeni Şifre (Opsiyonel)</label>
              <div className="password-input-wrapper">
                <Form.Control
                  id="password"
                  type={showPassword ? "text" : "password"}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Yeni şifrenizi giriniz (boş bırakabilirsiniz)"
                />
                <span
                  className="password-toggle"
                  onClick={togglePasswordVisibility}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </span>
              </div>
              <small className="form-text text-muted">
                Şifrenizi değiştirmek istemiyorsanız bu alanı boş bırakabilirsiniz.
              </small>
            </div>

            <div className="form-group password-field">
              <label htmlFor="confirmPassword">Yeni Şifre Tekrar</label>
              <div className="password-input-wrapper">
                <Form.Control
                  id="confirmPassword"
                  type={showConfirmPassword ? "text" : "password"}
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  placeholder="Yeni şifrenizi tekrar giriniz"
                />
                <span
                  className="password-toggle"
                  onClick={toggleConfirmPasswordVisibility}
                >
                  {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                </span>
              </div>
            </div>

            <div className="login-details-actions">
              <Button
                variant="primary"
                onClick={updateLoginDetail}
                disabled={updating}
                className="btn-save"
              >
                {updating ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Güncelleniyor...
                  </>
                ) : (
                  "Kaydet - Güncelle"
                )}
              </Button>
              <Button variant="outline-secondary" onClick={handleShow}>
                Sözleşmeyi Görüntüle
              </Button>
            </div>
          </div>
        </div>

        <Modal show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Sözleşme Detayları</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Burada ilgili yerden gelecek olan bir sözleşme metni olacaktır.
            Kullanıcı kabul ettiği sözleşmeyi burada görüntüleyebilecektir.
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Okudum anladım
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
};

export default LoginDetails;
